import React from 'react';
import { useCompare } from './CompareContext.js';

export default function CompareButton({ course, className = '' }) {
  const { has, toggle } = useCompare();
  const selected = has(course.slug);

  function handleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    toggle(course);
  }

  return (
    <button
      type="button"
      className={`compare-toggle${selected ? ' selected' : ''} ${className}`.trim()}
      aria-pressed={selected}
      onClick={handleClick}
    >
      <span className="compare-toggle-box" aria-hidden>
        {selected ? '✓' : ''}
      </span>
      {selected ? 'Added to compare' : 'Add to compare'}
    </button>
  );
}
